export const ticketTypeIsueOptionsData = [
    {
        label: "Shipment - Request",
        options: [
            { label: "OTP Request", value: "OTP Request" },
            { label: "Urgent Delivery", value: "Urgent Delivery" },
            { label: "Reattempt", value: "Reattempt" },
            { label: "RTO Instruction", value: "RTO Instruction" },
            { label: "Self collect - Branch address required", value: "Self collect - Branch address required" },
            { label: "Alternate contact / address", value: "Alternate contact / address" },
            { label: "POD required", value: "POD required" },
            { label: "Tech Error", value: "Tech Error" },
            { label: "Hold shipment", value: "Hold shipment" },
        ],
    },
    {
        label: "Shipment - Complaint",
        options: [
            { label: "Fake NDR", value: "Fake NDR" },
            { label: "Forward stuck in transit", value: "Forward stuck in transit" },
            { label: "RTO stuck in transit", value: "RTO stuck in transit" },
            { label: "Fake delivery updated", value: "Fake delivery updated" },
            { label: "RTO undelivered", value: "RTO undelivered" },
            { label: "Wrong product received", value: "Wrong product received" },
        ],
    },
    {
        label: "Shipment - Query",
        options: [
            { label: "Shipment Status", value: "Shipment Status" },
            { label: "Claim Status", value: "Claim Status" },
        ],
    },
    {
        label: "Other",
        options: [
            { label: "Billing & Remittance", value: "Billing & Remittance" },
            { label: "Weight Disputes", value: "Weight Related Issues" },
            { label: "Tech Disputes", value: "Tech Related Issues" },
            // { label: "Callback Request", value: "Callback Request" },
        ],
    }
];
